import { Component } from '@angular/core';

@Component({
  selector: 'app-home-sorteios',
  templateUrl: './home-sorteios.component.html',
  styleUrls: ['./home-sorteios.component.css']
})
export class HomeSorteiosComponent {
}



// WEBPACK FOOTER //
// ./src/app/publico/sorteios/home-sorteios/home-sorteios.component.ts